import React from 'react'
import { ShareButtons } from 'shared'

export const AbSharingContainer = ({ shareUrl }: { shareUrl: string }): JSX.Element => {
  return (
    <div className="bg-green-500 pt-12 pb-11" id="share">
      <div className="container">
        <div className="row">
          <div className="col-md-24 text-center">
            <h2 className="text-white mt-0 mb-4">{I18n.t('projects.show.sharing.headline')}</h2>
            <div className="row">
              <div className="col-md-6 offset-md-9">
                <ShareButtons
                  platforms={['facebook', 'twitter', 'email', 'whatsapp', 'messenger']}
                  mobileOnly={['whatsapp', 'messenger']}
                  shape="round"
                  shareUrl={shareUrl}
                  gaLabel="ppp_sharing_module"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
